// 文件: assets/accordion-smooth.js

(() => {
  // 初始化平滑折叠面板
  function initSmoothAccordions() {
    document.querySelectorAll('.accordion details').forEach(details => {
      const content = details.querySelector('.accordion__content');
      const summary = details.querySelector('summary');
      
      // 检查是否应该初始展开
      const shouldBeOpen = details.getAttribute('data-open') === 'open';
      
      // 设置初始状态
      if (!shouldBeOpen && !details.open) {
        // 默认关闭状态
        details.open = false;
        content.style.height = '0px';
        content.style.opacity = '0';
        content.style.padding = '0 1rem 0';
        content.style.overflowY = 'hidden';
      } else {
        // 应该展开的状态（包括已经通过 open 属性展开的）
        details.open = true;
        // 确保内容完全可见，移除任何高度限制
        content.style.height = 'auto';
        content.style.maxHeight = 'none';
        content.style.opacity = '1';
        content.style.padding = '';
        content.style.overflowY = 'visible';
      }
      
      // 重新绑定点击事件，避免重复绑定
      summary.removeEventListener('click', handleClick);
      summary.addEventListener('click', handleClick);
      
      // 点击处理函数
      function handleClick(e) {
        e.preventDefault();
        
        if (details.open) {
          // 关闭面板
          // 在关闭前，确保可以获取完整的高度
          content.style.overflowY = 'hidden';
          content.style.height = content.scrollHeight + 'px';
          requestAnimationFrame(() => {
            content.style.height = '0px';
            content.style.opacity = '0';
            content.style.paddingTop = '0';
            content.style.paddingBottom = '0';
          });
          
          content.addEventListener('transitionend', function closePanel() {
            details.open = false;
            content.removeEventListener('transitionend', closePanel);
          }, {once: true});
        } else {
          // 打开面板
          details.open = true;
          // 在计算高度前，临时设置 overflow 和 height 以获取准确高度
          content.style.overflowY = 'hidden';
          content.style.height = 'auto';
          // 使用 requestAnimationFrame 确保浏览器已经计算了布局
          requestAnimationFrame(() => {
            const targetHeight = content.scrollHeight;
            // 设置固定高度用于过渡动画
            content.style.height = targetHeight + 'px';
            content.style.opacity = '1';
            content.style.paddingTop = '';
            content.style.paddingBottom = '';
            
            // 使用多个事件来确保高度被正确设置
            let heightSet = false;
            const setAutoHeight = () => {
              if (details.open && !heightSet) {
                heightSet = true;
                content.style.height = 'auto';
                content.style.maxHeight = 'none';
                content.style.overflowY = 'visible';
              }
            };
            
            // 监听所有可能的过渡结束事件
            ['transitionend', 'webkitTransitionEnd', 'oTransitionEnd'].forEach(eventName => {
              content.addEventListener(eventName, setAutoHeight, {once: true});
            });
            
            // 备用方案：如果过渡事件没有触发，使用延迟设置
            setTimeout(() => {
              if (details.open) {
                setAutoHeight();
              }
            }, 500); // 500ms 应该足够完成过渡动画
          });
        }
      }
    });
  }
  
  // 在DOM加载完成后初始化
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSmoothAccordions);
  } else {
    initSmoothAccordions();
  }
  
  // 兼容Shopify主题编辑器
  document.addEventListener('shopify:section:load', initSmoothAccordions);
  
  // 暴露全局方法供手动调用
  window.refreshAccordions = initSmoothAccordions;
})();